import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  cursor: pointer !important;
  float: right;
  height: 30px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  background-color: #f7f7f7;
  border: 1px solid #ddd;
  color: #333;
  position: relative;
  outline: 0;
  box-sizing: border-box;
  -webkit-border-radius: 3px;
  font-size: 13px;
`;

const ButtonStyledSpan = styled.span`
  font-size: 12px;
  line-height: normal;
  text-align: center;
  color: #333333;
  padding: 10px;
`;

// const BadgeStyledSpan = styled.span`
//   position: absolute;
//   background-color: #bf0000;
//   -webkit-border-radius: 50%;
//   display: ${(props: { show: boolean }) =>
//     props.show ? 'inline-block' : 'none'};
//   left: 100px;
//   bottom: 24px;
//   padding: 4px !important;
// `;

interface Props {
  onClick: any;
  showUnreadBadgeSpan: boolean;
}

export const InquiryHeaderButton = (props: Props) => {
  const { onClick } = props;

  return (
    <StyledDiv data-testid="headerTopLink" onClick={onClick}>
      {/* without forceHtmlLink, it shows loading icon and update nothing when click this button */}
      <ButtonStyledSpan>問い合わせ一覧</ButtonStyledSpan>
      {/* for future expansion
      <BadgeStyledSpan show={showUnreadBadgeSpan} />
      */}
    </StyledDiv>
  );
};
